import { NumberField } from 'react-aria-components'
import { InputBase } from './shared/input'
import { Slider } from './shared/slider/slider'

export function CustomizeStrokeWidth({
	strokeWidth,
	setStrokeWidth,
}: {
	strokeWidth: string
	setStrokeWidth: (strokeWidth: string) => void
}) {
	return (
		<>
			<h2 className="text-primary text-sm font-semibold">Stroke Width</h2>

			<div className="mt-4 grid grid-cols-[64px_1fr] items-center gap-4">
				<NumberField
					aria-label="Stroke Width"
					value={Number(strokeWidth)}
					minValue={0.25}
					maxValue={3}
					step={0.25}
					onChange={(value) => {
						setStrokeWidth(value.toString())
					}}
				>
					<InputBase inputClassName="text-center" />
				</NumberField>

				<Slider
					aria-label="Stroke Width Slider"
					formatOptions={{
						style: 'decimal',
						maximumFractionDigits: 2,
					}}
					value={Number(strokeWidth)}
					minValue={0.25}
					maxValue={3}
					step={0.25}
					onChange={(value) => {
						if (typeof value !== 'number') {
							return
						}
						setStrokeWidth(value.toString())
					}}
				></Slider>
			</div>
		</>
	)
}
